export default {
    data() {
        return {
            // 名称
            logName: '',
            // 内容
            logContent: '',
            // 回答的内容
            textarea: '',
            // 是否有回答过问题，回答过的话再回答就是更新之前提交的内容
            answered: false,
        }
    },
    props: {
        resource_id: Number,
        purchased_id: Number,
        exercise_num: Number,
        product_id: Number,
        task_id: Number,
    },
    methods: {
        // 获取课后习题资源
        getData() {
            this.$post('resources/get', {
                token: this.$store.state.id,
                id: this.resource_id
            }).then(res => {
                this.logName = res.data.result.name
                this.logContent = res.data.result.data
            })
        },

        // 提交
        submit() {
            // 判断字数是否符合要求
            let length = this.textarea.length;
            if (this.exercise_num > length) {
                this.$alert(`您输入的字数不符合要求，最少输入${this.exercise_num}字`, '提示', {
                    confirmButtonText: '确定',
                });
                return;
            }
            // 提交研修日志内容
            this.submitLogData();
        },

        // 获取研修日志资源
        getLogData() {
            this.$post('user_training_log/getTrainingLog', {
                token: this.$store.state.id,
                shop_id: this.$store.state.store.id,
                product_id: this.product_id,
                task_id: this.task_id
            }).then(res => {
                let result = res.data.result;
                result ? this.textarea = result.private : this.textarea = '';

                this.$isAbnormal(this.textarea) ? this.answered = false : this.answered = true;
            });
        },

        // 提交研修日志内容
        submitLogData() {
            this.$post('user_training_log/addTrainingLog', {
                token: this.$store.state.id,
                shop_id: this.$store.state.store.id,
                product_id: this.product_id,
                task_id: this.task_id,
                private: this.textarea,
            }).then(res => {
                if (res.data.status == 'success') {
                    this.$message.success('提交成功！');
                    this.answered = true;
                    this.$emit('saveLog', 2); // 向父组件传值
                } else {
                    this.$message.error('提交失败，请重试！');
                }
            });
        },
    },
    mounted() {
        // 获取习题资源
        this.getData();
        // 获取研修日志资源
        this.getLogData();
    },
}